// extracted by css-extract-rspack-plugin
export default {"item":"_da7e1536","active":"_f6b0bd8f","link":"_b1c608a3"};